import { useQuery } from '@tanstack/react-query';
import { resourceQueryKeys } from './resourceQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryResourceSummary = (parentId, queryOptions) => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const query = useQuery({
    queryKey: resourceQueryKeys.totals(parentId),
    queryFn: async ({ queryKey }) => {
      const parentSafe = queryKey[1];
      return await client.v2({
        endpoint: "/v2/folders/{folderId}/counts",
        params: {
          folderId: parentSafe
        }
      });
    },
    refetchInterval: 45e3,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!user,
      queryOptions?.enabled,
      !!parentId
    ])
  });
  return query;
};

export { useQueryResourceSummary };
//# sourceMappingURL=useQueryResourceSummary.js.map
